/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  VerifyResetTokenErrorResponse,
  VerifyResetTokenRequest,
  VerifyResetTokenResponse,
} from './api.schemas';

import { api } from '../util/http';

export const verifyResetToken = (
  verifyResetTokenRequest: VerifyResetTokenRequest,
  signal?: AbortSignal,
) => {
  return api<VerifyResetTokenResponse>({
    url: `/api/auth/verify-reset-token`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: verifyResetTokenRequest,
    signal,
  });
};

export const getVerifyResetTokenMutationOptions = <
  TError = VerifyResetTokenErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyResetToken>>,
    TError,
    { data: VerifyResetTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyResetToken>>,
  TError,
  { data: VerifyResetTokenRequest },
  TContext
> => {
  const mutationKey = ['verifyResetToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyResetToken>>,
    { data: VerifyResetTokenRequest }
  > = (props) => {
    const { data } = props ?? {};

    return verifyResetToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyResetTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyResetToken>>
>;
export type VerifyResetTokenMutationBody = VerifyResetTokenRequest;
export type VerifyResetTokenMutationError = VerifyResetTokenErrorResponse;

export const useVerifyResetToken = <TError = VerifyResetTokenErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyResetToken>>,
      TError,
      { data: VerifyResetTokenRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyResetToken>>,
  TError,
  { data: VerifyResetTokenRequest },
  TContext
> => {
  const mutationOptions = getVerifyResetTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
